module.exports = __webpack_public_path__ + "static/img/joinUs_06.360dfc5f.jpg";